/*
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-01 11:29:10
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-05-08 15:42:38
 */

import wx from 'weixin-js-sdk';
import store from '@/store';
//判断浏览器（微信、小程序）
function browserUA() {
    return new Promise(resolve => {
        const ua = navigator.userAgent.toLowerCase();
        if (ua.match(/MicroMessenger/i) == "micromessenger") {
            wx.miniProgram.getEnv(res => {
                if (res.miniprogram) {
                    store.commit("SET_BROWSERUA", "MINI");
                } else {
                    store.commit("SET_BROWSERUA", "WX");
                }
                resolve(store.getters.browserUA);
            });
        } else if (ua.indexOf("vpShopApp".toLowerCase()) != -1) {
            if (ua.indexOf("vpShopApp_Android".toLowerCase()) != -1) {
      //          store.commit("SET_BROWSERUA", "APP");
                   store.commit("SET_BROWSERUA", "androidAPP");
            } else if (ua.indexOf("vpShopApp_ios".toLowerCase()) != -1) {
      //          store.commit("SET_BROWSERUA", "APP");
                    store.commit("SET_BROWSERUA", "iosAPP");
            }
            resolve(store.getters.browserUA);
        } else {
            store.commit("SET_BROWSERUA", "NOTWX");
            resolve(store.getters.browserUA);
        }
    });
}

export { browserUA }